/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { faComments, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { forwardRef, useEffect, useMemo, useState } from 'react';
import { Accordion, Col, Form, OverlayTrigger, Row, Tooltip, Badge } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { getSurveyShareALink } from '../../actions/survey.details.action';
import { CHART_TYPES, HIGHCHARTS_TYPES } from '../../constants/charts';
import { parseMLIData } from '../../helpers/charts';
import types from '../../types';
import ExportModal from '../ExportModal';
import RelatedQuestion from '../RelatedQuestion';
import BarChart from './BarChart';
import BarChartUneven from './BarChartUneven';
import ColumnChart from './ColumnChart';
import DonutChart from './DonutChart';
import HeatMapChart from './HeatMapChart';
import RadarChart from './RadarChart';
import WaffleChart from './WaffleChart';

import validateOnboardingStep from '../../constants/validateOnboardingStep';
import benTooltip from '../BenTooltip';
import { postOnBoardingProcess } from '../../actions/user.action';
import { ONBOARDING_STEPS, QUESTION_VALUE_TYPE } from '../../constants/common';
import ChartAccordionToggle from './ChartAccordionToggle';
import './styles.css';

export const HeaderFooterMenuCustomToggle = forwardRef(({ children, onClick }, ref) => (
  <span
    className="cursor-pointer"
    ref={ref}
    onClick={(e) => {
      e.preventDefault();
      e.stopPropagation();
      onClick(e);
    }}
  >
    {children}
    <FontAwesomeIcon size="lg" className="mt-3" icon={faComments} />
  </span>
));

HeaderFooterMenuCustomToggle.displayName = 'HeaderFooterMenuCustomToggle';

const Chart = forwardRef(
  (
    {
      memberIdx,
      currentJob,
      visualization,
      currentCategory,
      isRelated,
      updateChartType,
      updateBenchmark,
      questionsCategories,
      onExport,
      spaceAdded = true,
      onSelectedQuestion = () => {},
      isEditing = false,
    },
    chartRef
  ) => {
    const dispatch = useDispatch();
    const storeJwt = useSelector((state) => state.session.jwt);
    const { openedQuestions } = useSelector((state) => state.surveyDetails);
    const { sample } = useSelector((state) => state.surveySample);
    const { onBoarding } = useSelector((state) => state.users);

    const isOrganizationSurvey = !!currentJob?.queryResult?.organization?.id;
    const [wasChartRendered, setWasChartRendered] = useState(
      openedQuestions.includes(currentJob?.id)
    );
    const [currentChartType, setCurrentChartType] = useState(
      visualization?.details?.chartSettings?.chartSettings[currentJob.id]?.selectedChartType ||
        currentJob?.defaultVisualizationType ||
        ''
    );
    const shouldRenderChart = useMemo(() => {
      return openedQuestions.includes(currentJob?.id) || wasChartRendered;
    }, [wasChartRendered, openedQuestions]);

    const [currentBenchmark, setCurrentBenchmark] = useState(
      visualization?.details?.chartSettings?.chartSettings[currentJob.id]?.benchmarks || {
        national: false,
        state: false,
      }
    );
    const [parsedData, setParsedData] = useState();
    const [checked, setChecked] = useState(false);

    const anyGeneralQuestionFilterApplies = useMemo(() => {
      return !!visualization?.details?.filter?.constraintGroups?.length;
    }, [visualization?.details?.filter?.constraintGroups]);

    const onCenterScroll = (job) => {
      setTimeout(() => {
        const element = document.getElementById(`chart-id-${job.id}`);
        if (!element) return;
        console.log('Question element', element);
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      }, 200);
    };

    const anySegmentApplies = useMemo(() => {
      if (!visualization?.details?.segments) return false;
      return !!visualization?.details?.segments?.find((segment) => segment.active);
    }, [visualization]);

    useEffect(() => {
      if (currentJob && currentJob?.queryResult && currentCategory) {
        if (isEditing && !sample) return;
        const co = parseMLIData(
          currentJob,
          currentJob?.queryResult,
          currentBenchmark,
          currentCategory,
          visualization?.details?.scheme?.index,
          currentChartType,
          visualization?.details?.enableDefaultSegment,
          sample
        );
        setParsedData(co);
        onCenterScroll(currentJob);
      }
    }, [currentJob, sample, visualization, currentCategory, currentBenchmark, currentChartType]);

    const handleChartLoaded = () => console.log(false);

    const handleAddToReport = (e) => {
      e.stopPropagation();
      e.preventDefault();
      const reportItem = {
        visualizationDetails: visualization?.details,
        visualizationId: visualization?.id,
        contextType: 'QUESTION', // TODO - figure out from where to get this if not a question
        contextIds: [currentJob?.id],
      };
      dispatch({ type: types.reducerTypes.REPORT_MODAL_SHOW, payload: reportItem });
    };

    const handleChangeChart = (e, chartName) => {
      e.stopPropagation();
      e.preventDefault();
      setCurrentChartType(chartName);
      updateChartType(currentJob, chartName);
    };

    const handleBenchmarkChange = (e, newBenchmark) => {
      const benchmark = {
        ...visualization?.details?.chartSettings?.chartSettings[currentJob.id]?.benchmarks,
        ...newBenchmark,
      };
      e.stopPropagation();
      e.preventDefault();
      setCurrentBenchmark(benchmark);
      updateBenchmark(currentJob, benchmark);
    };

    const handleShareALink = (e) => {
      e.stopPropagation();
      e.preventDefault();
      dispatch(
        getSurveyShareALink(visualization?.id, visualization?.contextId, currentJob?.id, storeJwt)
      );
    };

    const handleExport = (e) => {
      e.stopPropagation();
      e.preventDefault();
      onExport(currentJob.id);
    };

    const renderCurrentSampleSize = () => {
      if (
        visualization?.details?.enableDefaultSegment &&
        Array.isArray(currentJob?.queryResult?.mliDataSegments)
      ) {
        const sampleSizeSegment = currentJob?.queryResult?.mliDataSegments?.find(
          (ds) => ds.name === 'default'
        );
        const splitNumberInterval = sampleSizeSegment?.numberOfRespondentsInterval?.split('-');
        return (
          <>
            <h3>N-Size</h3>
            <div className="pl-4 pt-3">
              {!isOrganizationSurvey &&
                Array.isArray(splitNumberInterval) &&
                Number(splitNumberInterval[0]) < 50 && (
                  <OverlayTrigger
                    trigger={['hover', 'hover']}
                    placement="top"
                    overlay={
                      <Tooltip id="tooltip-n-size">
                        Sample may not be representative: use caution when interpreting results.
                      </Tooltip>
                    }
                  >
                    <FontAwesomeIcon icon={faExclamationTriangle} color="red" className="mr-3" />
                  </OverlayTrigger>
                )}
              {sampleSizeSegment?.numberOfRespondentsInterval}
            </div>
          </>
        );
      }
      return null;
    };

    const saveStepHandler = (step) => {
      onBoarding.push(step.value);
      dispatch(postOnBoardingProcess({ steps: onBoarding }, storeJwt));
    };

    const onToggleAccordion = () => {
      if (wasChartRendered && isEditing) {
        onSelectedQuestion(null);
        return;
      }
      setWasChartRendered(true);
      dispatch({
        type: types.reducerTypes.SURVEY_DETAILS_TOGGLE_OPEN_QUESTIONS,
        payload: {
          toggleQuestionId: currentJob?.id,
          isInit: false,
        },
      });
      onSelectedQuestion(currentJob?.id);
      onCenterScroll(currentJob);
    };

    return (
      <div className="position-relative w-100">
        {currentJob?.id && (
          <Accordion className={`w-100 ${spaceAdded ? 'px-5' : ''}`}>
            <div
              className={`w-100 text-left border-0 bg-gray-200 d-flex ${
                spaceAdded ? 'mt-5' : 'mt-1'
              }`}
              id={currentJob?.id}
            >
              <div className="w-100">
                <ChartAccordionToggle
                  displayIdentifier={currentJob?.displayIdentifier}
                  prompt={currentJob?.prompt}
                  onToggleAccordion={onToggleAccordion}
                  handleExport={handleExport}
                  handleAddToReport={handleAddToReport}
                  handleChangeChart={handleChangeChart}
                  handleBenchmarkChange={handleBenchmarkChange}
                  handleShareALink={handleShareALink}
                  currentJob={currentJob}
                  currentChartType={currentChartType}
                  currentBenchmark={currentBenchmark}
                  visualization={visualization}
                  anySegmentApplies={anySegmentApplies}
                  eventKey={parsedData && shouldRenderChart}
                  isEditing={isEditing}
                />
              </div>
            </div>
            <Accordion.Collapse
              className={`accordion-${currentJob?.id}`}
              in={Boolean(currentJob?.id)}
            >
              <div>
                {parsedData && shouldRenderChart && (
                  <Row noGutters className="bg-white">
                    <OverlayTrigger
                      placement="top"
                      defaultShow={validateOnboardingStep(
                        ONBOARDING_STEPS.step7.value,
                        ONBOARDING_STEPS.step7.previous,
                        onBoarding
                      )}
                      show={validateOnboardingStep(
                        ONBOARDING_STEPS.step7.value,
                        ONBOARDING_STEPS.step7.previous,
                        onBoarding
                      )}
                      overlay={(props) =>
                        benTooltip({
                          ...props,
                          title: ONBOARDING_STEPS.step7.title,
                          content: ONBOARDING_STEPS.step7.content,
                          close: () => saveStepHandler(ONBOARDING_STEPS.step7),
                        })
                      }
                    >
                      <Col md="9" className="pl-3 pt-3" id={`chart-id-${currentJob.id}`}>
                        {currentChartType === CHART_TYPES.STACKED_BAR && (
                          <BarChart
                            parsedData={parsedData}
                            benchmarks={currentBenchmark}
                            qtyOptions={
                              currentJob?.answers?.length ||
                              currentJob?.answerOptionsType?.length ||
                              1
                            }
                            chartLoaded={handleChartLoaded}
                            currentJob={currentJob}
                            ref={chartRef}
                            isEditing={isEditing}
                          />
                        )}
                        {currentChartType === CHART_TYPES.HORIZONTAL_BAR && (
                          <ColumnChart
                            parsedData={parsedData}
                            currentJob={currentJob}
                            chartType={HIGHCHARTS_TYPES.BAR}
                            benchmarks={currentBenchmark}
                            colorScheme={visualization?.details?.scheme?.index}
                            qtyOptions={
                              currentJob?.answers?.length ||
                              currentJob?.answerOptionsType?.length ||
                              1
                            }
                            chartLoaded={handleChartLoaded}
                            ref={chartRef}
                          />
                        )}
                        {currentChartType === CHART_TYPES.COLUMN && (
                          <ColumnChart
                            parsedData={parsedData}
                            currentJob={currentJob}
                            benchmarks={currentBenchmark}
                            chartLoaded={handleChartLoaded}
                            ref={chartRef}
                            colorScheme={visualization?.details?.scheme?.index}
                            qtyOptions={
                              currentJob?.answers?.length ||
                              currentJob?.answerOptionsType?.length ||
                              1
                            }
                          />
                        )}
                        {currentChartType === CHART_TYPES.DONUT && (
                          <DonutChart
                            segmented={visualization?.details?.segments?.length > 0}
                            parsedData={parsedData}
                            chartLoaded={handleChartLoaded}
                            ref={chartRef}
                            benchmarks={currentBenchmark}
                          />
                        )}
                        {currentChartType === CHART_TYPES.HEAT_MAP && (
                          <HeatMapChart
                            parsedData={parsedData}
                            chartLoaded={handleChartLoaded}
                            ref={chartRef}
                            qtyOptions={
                              currentJob?.answers?.length ||
                              currentJob?.answerOptionsType?.length ||
                              1
                            }
                            benchmarks={currentBenchmark}
                            currentJob={currentJob}
                          />
                        )}
                        {currentChartType === CHART_TYPES.RADAR && (
                          <RadarChart
                            parsedData={parsedData}
                            chartLoaded={handleChartLoaded}
                            ref={chartRef}
                          />
                        )}
                        {(currentChartType === CHART_TYPES.SPLIT_BAR_POS_NEG ||
                          currentChartType === CHART_TYPES.COMBINED_BAR_POS_NEG) && (
                          <BarChartUneven
                            parsedData={parsedData}
                            chartLoaded={handleChartLoaded}
                            ref={chartRef}
                            benchmarks={currentBenchmark}
                            currentJob={currentJob}
                          />
                        )}
                        {currentChartType === CHART_TYPES.WAFFLE && (
                          <WaffleChart
                            parsedData={parsedData}
                            qtyOptions={
                              currentJob?.answers?.length ||
                              currentJob?.answerOptionsType?.length ||
                              1
                            }
                            chartLoaded={handleChartLoaded}
                            ref={chartRef}
                            benchmarks={currentBenchmark}
                            scheme={visualization?.details?.scheme}
                          />
                        )}
                      </Col>
                    </OverlayTrigger>
                    <Col md="3" className="p-2 d-flex flex-column">
                      <div>
                        <h2 className="border-bottom border-dark w-50 text-uppercase pb-3 mb-3">
                          Sample Size
                        </h2>
                      </div>
                      {renderCurrentSampleSize()}
                      {visualization?.details?.segments?.map((s) => {
                        const sampleSizeSegment = currentJob?.queryResult?.mliDataSegments?.find(
                          (ds) => ds.name === s.label
                        );
                        const splitNumberInterval = sampleSizeSegment?.numberOfRespondentsInterval?.split(
                          '-'
                        );
                        return (
                          <>
                            <h3>N-Size - {sampleSizeSegment?.name}</h3>
                            <div className="pl-4 pt-3">
                              {!isOrganizationSurvey &&
                                Array.isArray(splitNumberInterval) &&
                                Number(splitNumberInterval[0]) < 50 && (
                                  <OverlayTrigger
                                    trigger={['hover', 'hover']}
                                    placement="top"
                                    overlay={
                                      <Tooltip id="tooltip-n-size">
                                        Sample may not be representative: use caution when
                                        interpreting results.
                                      </Tooltip>
                                    }
                                  >
                                    <FontAwesomeIcon
                                      icon={faExclamationTriangle}
                                      color="red"
                                      className="mr-3"
                                    />
                                  </OverlayTrigger>
                                )}
                              {sampleSizeSegment?.numberOfRespondentsInterval}
                            </div>
                          </>
                        );
                      })}
                      {!spaceAdded && QUESTION_VALUE_TYPE.OPEN_TEXT !== sample?.Data.valueType && (
                        <div className="mt-3">
                          <h4>Active Filter Type</h4>
                          <Badge pill variant="dark">
                            {sample?.Data?.filterType}
                          </Badge>
                        </div>
                      )}
                      {isRelated && (
                        <div className="switch rel pt-3">
                          <div>
                            {anyGeneralQuestionFilterApplies || anySegmentApplies ? (
                              <OverlayTrigger
                                trigger={['hover', 'hover']}
                                placement="top"
                                overlay={
                                  <Tooltip id="tooltip-related-question">
                                    Related survey results unavailable
                                  </Tooltip>
                                }
                              >
                                <h3 className="related-survey-title rel">
                                  {currentJob?.relatedSurveyName}
                                </h3>
                              </OverlayTrigger>
                            ) : (
                              <h3 className="related-survey-title rel">
                                {currentJob?.relatedSurveyName}
                              </h3>
                            )}
                          </div>
                          {isRelated && !anyGeneralQuestionFilterApplies && !anySegmentApplies && (
                            <div className="related-survey-tooltip rel">
                              <Form>
                                <Form.Check
                                  type="switch"
                                  id={`${currentJob?.id}-${memberIdx}`}
                                  onChange={() => {
                                    setChecked(!checked);
                                  }}
                                />
                              </Form>
                            </div>
                          )}
                        </div>
                      )}
                    </Col>
                    {checked && isRelated && currentJob?.queryResult?.relatedQuestions && (
                      <RelatedQuestion
                        relatedQuestion={currentJob?.queryResult?.relatedQuestions[0]}
                        relatedSurveyName={currentJob?.relatedSurveyName}
                        visualization={visualization}
                        chartLoaded={handleChartLoaded}
                        ref={chartRef}
                        currentBenchmark={currentBenchmark}
                        currentCategory={questionsCategories?.find(
                          (qc) => qc?.key_id === currentJob?.relatedQuestionId
                        )}
                      />
                    )}
                    <ExportModal />
                  </Row>
                )}
                {!parsedData && <div />}
              </div>
            </Accordion.Collapse>
          </Accordion>
        )}
      </div>
    );
  }
);

Chart.displayName = 'Chart';

export default React.memo(Chart);
